// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__FqKeW","large":"styles_large__3K251"};